"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RadioComponent = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = require("react");
var _radio = _interopRequireDefault(require("@ux/radio"));
require("@ux/radio/styles");
var _storeProvider = require("./../util/storeProvider");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const getTermTypeText = (termType, content, numberOfTerms) => {
  let termTypeText;
  switch (termType) {
    case 'MONTH':
      termTypeText = numberOfTerms > 1 ? content.monthPlural : content.monthSingular;
      break;
    case 'YEAR':
      termTypeText = numberOfTerms > 1 ? content.yearPlural : content.yearSingular;
      break;
    default:
      termTypeText = '';
      break;
  }
  return termTypeText;
};
class RadioComponent extends _react.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }
  handleChange(_, e) {
    const {
      value
    } = e.event.target;
    const {
      handleChange
    } = this.props;
    handleChange(value || 'none');
  }
  render() {
    const {
      instancePath,
      content,
      enumVal,
      selectedVal,
      disabled,
      layoutProperties,
      termType,
      commonContent
    } = this.props;
    const {
      store
    } = this.context;

    // intentionally not comparing type
    const checked = selectedVal == enumVal; // eslint-disable-line

    let title = content.title;
    let id = instancePath + '.' + title;
    id = id.replace(' ', '-');

    // TODO: Remove ternary once content.title supports {termType}
    if (layoutProperties.display === 'termSelector') {
      title = content.title && content.title.includes('{termType}') ? content.title.replace('{termType}', getTermTypeText(termType, commonContent, enumVal)).trim() : content.title;
    }
    return /*#__PURE__*/React.createElement("div", null, content['feature-highlight-text'] && /*#__PURE__*/React.createElement("span", {
      className: "attr-highlight-mesg bg-warning-highlight px-1"
    }, /*#__PURE__*/React.createElement("strong", null, content['feature-highlight-text'])), /*#__PURE__*/React.createElement(_radio.default, {
      className: checked ? 'selected' : '',
      id: id,
      name: instancePath,
      "data-eid": store.getEid(enumVal, 'radio', checked ? 'deselect' : 'select'),
      label: /*#__PURE__*/React.createElement("h5", {
        className: "mb-0"
      }, title),
      onChange: this.handleChange,
      checked: checked,
      value: enumVal == 'none' ? false : enumVal // eslint-disable-line
      ,
      disabled: disabled
    }));
  }
}
exports.RadioComponent = RadioComponent;
RadioComponent.propTypes = {
  disabled: _propTypes.default.bool,
  handleChange: _propTypes.default.func.isRequired,
  content: _propTypes.default.object.isRequired,
  commonContent: _propTypes.default.object.isRequired,
  selectedVal: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string, _propTypes.default.number]),
  instancePath: _propTypes.default.string.isRequired,
  layoutProperties: _propTypes.default.object,
  enumVal: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string, _propTypes.default.number]),
  termType: _propTypes.default.string
};
var _default = exports.default = (0, _storeProvider.provideContext)(RadioComponent);